import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import clone from 'clone';
import _ from 'lodash';
import { required, matchRegex } from '@mhub/web-validations';
import {
  Button,
  Grid,
} from 'semantic-ui-react';
import qs from 'qs';

import AppForm from '../../components/AppForm';
import { REG_URL } from '../../constants/regex';
import { fetchM } from '../../actions/fetchM';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import { flashErrorMessage } from '../../actions/flash';

// const mediaTypes = [
//   { key: 'video', text: 'Video', value: 'video' },
// ];

class MediaForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    t: PropTypes.func,
    media: PropTypes.shape({
      id: PropTypes.string,
      url: PropTypes.string,
      type: PropTypes.string,
      label: PropTypes.string,
    }),
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static defaultValues = {
    url: '',
    type: 'video',
    label: '',
  }
  constructor(props) {
    super(props);
    const media = Object.assign({}, MediaForm.defaultValues, props.media || {});
    let oembed = null;
    if (media.data) {
      oembed = media.data;
    }
    this.state = {
      media,
      oriMedia: clone(media),
      loading: false,
      errMessages: [],
      hasChanges: false,
      urlSupported: false,
      oembed,
    };
    this.validation = {
      url: createRef(),
      // type: createRef(),
    };
  }
  componentWillReceiveProps(nextProps) {
    let media = Object.assign({}, MediaForm.defaultValues, this.state.media);
    let { oembed, oriMedia } = this.state;
    if (JSON.stringify(this.props.media) !== JSON.stringify(nextProps.media)) {
      media = Object.assign(media, nextProps.media);
      oriMedia = clone(media);

      if (media.data) {
        oembed = media.data;
      }
    }
    this.setState({
      media,
      oriMedia,
      oembed,
    });
  }
  setComponentState = (state = {}) => new Promise((res) => {
    this.setState(state, () => {
      res(state);
    });
  });
  setLoading = (loading = false) => new Promise((res) => {
    this.setState({ loading }, () => {
      res(loading);
    });
  });
  fetchOEmbedData = async () => {
    const { t } = this.props;
    const { store } = this.context;
    const { media } = this.state;
    if (!media.url) {
      return;
    }
    const validations = await AppForm.validate(this.validation, media);
    const errors = validations.filter(v => !v.isValid);
    if (errors.length > 0) {
      return;
    }

    await this.setLoading(true);
    const query = {
      url: media.url,
    };
    let res;
    try {
      res = await store.dispatch(fetchM(`/oembed/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      if (e.res && e.res.status >= 400 && e.res.status < 500) {
        const message = await e.res.text();
        store.dispatch(flashErrorMessage({ message }));
        await this.setComponentState({ urlSupported: false });
        await this.setLoading(false);
        return;
      }
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setComponentState({ urlSupported: false });
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
      await this.setComponentState({ urlSupported: false });
    } else {
      const oembed = await res.json();
      if (oembed && oembed.title) {
        media.label = oembed.title;
      }
      await this.setComponentState({ oembed, media, urlSupported: true });
    }
    await this.setLoading(false);
  }
  submit(url, opts) {
    return this.form.submit(url, opts);
  }
  handleSubmit = (event) => {
    event.preventDefault();
    const { media } = this.state;
    AppForm.validate(this.validation, media)
      .then((validations) => {
        this.setState({
          errMessages: validations.filter(v => !v.isValid),
        });
        this.props.onSubmit(validations, media);
      });
  }
  checkHasChanges = (media = this.state) =>
    JSON.stringify(media) !== JSON.stringify(this.state.oriMedia);
  debounceFetchOEmbed = _.debounce(this.fetchOEmbedData, 1000);
  handleInputChange = (event, { name, value }) => {
    const { media } = this.state;
    let { oembed, urlSupported } = this.state;
    let newValue = value;
    if (name === 'label') {
      newValue = value.replace(/[\\~#%&*{}/:<>?|"]/, '');
    }
    media[name] = newValue;
    if (name === 'url') {
      oembed = null;
      urlSupported = false;
    }

    const hasChanges = this.checkHasChanges(media);
    this.setState({ media, oembed, hasChanges, urlSupported }, () => {
      if (name === 'url') {
        this.debounceFetchOEmbed(newValue);
      }
    });
  }
  render() {
    const { t } = this.props;
    const { media, oembed } = this.state;
    return (
      <AppForm
        onSubmit={this.handleSubmit}
        error={this.state.errMessages.length > 0}
        ref={(ref) => { this.form = ref; }}
      >
        <Grid stackable columns="equal" doubling>
          <Grid.Row>
            <Grid.Column>
              <h4>{t('Preview', { ns: TRANSLATION_FILES.screens })}</h4>
            </Grid.Column>
            <Grid.Column textAlign="right">
              <Button
                positive
                content={t('Create', { ns: TRANSLATION_FILES.screens })}
                onClick={this.handleSubmit}
                disabled={
                  !this.state.hasChanges ||
                  this.state.loading || (
                    this.state.hasChanges && !this.state.urlSupported
                  )}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign="center">
              {
                oembed ? (
                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                    }}
                    dangerouslySetInnerHTML={{ __html: oembed.html }}
                  />
                ) : null
              }
            </Grid.Column>
            <Grid.Column>
              <AppForm.Input
                validateLabel="URL"
                label={(
                  <label>
                    URL
                    <small
                      style={{
                        fontWeight: 100,
                        marginLeft: '0.5em',
                      }}
                    >
                      {t('Paste your YouTube or Vimeo video URL here. URLs from other platform are not supported.', { ns: TRANSLATION_FILES.translation })}
                    </small>
                  </label>
                )}
                name="url"
                value={media.url}
                onChange={this.handleInputChange}
                ref={this.validation.url}
                validation={[
                  required,
                  {
                    validate: matchRegex,
                    option: {
                      validRegex: REG_URL,
                    },
                  },
                ]}
                disabled={this.state.loading}
              />
              <AppForm.Input
                label={t('Label', { ns: TRANSLATION_FILES.screens })}
                name="label"
                value={media.label}
                onChange={this.handleInputChange}
                disabled={this.state.loading}
              />
              {/* <AppForm.Select
                label="Type"
                name="type"
                value={media.type}
                options={mediaTypes}
                onChange={this.handleInputChange}
                // ref={this.validation.type}
                // validation={[required]}
                disabled
              /> */}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </AppForm>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(MediaForm);



// WEBPACK FOOTER //
// ./src/containers/Videos/Form.jsx